import { ToggleButtonGroup } from "@mui/material"
import { CategoryFilterChip } from "components/CategoryFilterBar"

export const CinemaToggleButton = ({ value, onChange, cinemas }) => {
  return (
    <ToggleButtonGroup value={value} onChange={onChange} exclusive>
      {cinemas.map((cinema) => (
        <CategoryFilterChip key={cinema.value} value={cinema.value}>
          {cinema.label}
        </CategoryFilterChip>
      ))}
    </ToggleButtonGroup>
  )
}
